import moment from 'moment/moment'
import AdvancedFilters from '../AdvancedFilters'
import { useNavigate, useSearchParams } from 'react-router-dom-v5-compat'

const defaultFrom = moment().startOf('day').local()
const defaultTo = moment().endOf('day').local()

const Filters = () => {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()

    const from = new URLSearchParams(searchParams).get('from')
    const to = new URLSearchParams(searchParams).get('to')

    if (!from || !to) {
        const params = new URLSearchParams()
        params.append('from', defaultFrom)
        params.append('to', defaultTo)
        setSearchParams(params)
    }

    return (
      <AdvancedFilters
        filters={{
            dateRange: {
                minDate: moment().subtract(3, 'month'),
                maxDate: moment(),
                startDate: moment(from || defaultFrom),
                endDate: moment(to || defaultTo),
            },
        }}
        onFiltersChange={(filters) => {
            const params = new URLSearchParams()
            if (filters.dateRange.startDate) {
                params.append('from', filters.dateRange.startDate.startOf('day').toISOString())
            }
            if (filters.dateRange.endDate) {
                params.append('to', filters.dateRange.endDate.endOf('day').toISOString())
            }

            navigate({search: params.toString()})
        }}
      >
          <AdvancedFilters.DateRangeFilter/>
      </AdvancedFilters>
    )
}

export { Filters }
